import NextLink from "next/link";
import { useRouter } from "next/router";
import { Box, BoxProps, Link } from "@chakra-ui/react";

// Utils
import { getQueryString } from "utils/common";

interface Props extends BoxProps {
  link: string;
}

const subRoute = process.env.NEXT_PUBLIC_SUB_ROUTE || "";

const LinkComponent = ({ link, children, ...rest }: Props) => {
  const router = useRouter();

  const { query } = router;

  const queryString = getQueryString(query);

  return (
    <NextLink
      href={`${link}${queryString ? `?${queryString}` : ""}`}
      as={`/${subRoute}${link}${queryString ? `?${queryString}` : ""}`}
      passHref
    >
      <Link>
        <Box {...rest}>{children}</Box>
      </Link>
    </NextLink>
  );
};

export default LinkComponent;
